export type Coords = [x: number, y: number, z: number];

export const sRGBD65Matrix: [r: Coords, g: Coords, b: Coords] = [
    [3.2404542, -1.5371385, -0.4985314],
    [-0.9692660,  1.8760108,  0.0415560],
    [0.0556434, -0.2040259,  1.0572252]
  ];

/**
 * 50nm steps, starting from 390nm.
 * 
 * see: http://cvrl.ioo.ucl.ac.uk/
 */
export const spectrumCoordinates: Coords[] = [
  [0.17842,0.02464,0.79694],
  [0.17784,0.02509,0.79706],
  [0.17652,0.02432,0.79915],
  [0.17504,0.02279,0.80217],
  [0.17372,0.02185,0.80442],
  [0.17151,0.02106,0.80744],
  [0.16935,0.021,0.80966],
  [0.16672,0.02188,0.8114],
  [0.16408,0.02349,0.81243],
  [0.16074,0.02632,0.81294],
  [0.15769,0.02925,0.81306],
  [0.154,0.0336,0.8124],
  [0.14977,0.03958,0.81065],
  [0.14423,0.04951,0.80626],
  [0.13627,0.06397,0.79976],
  [0.12634,0.08482,0.78884],
  [0.11247,0.1175,0.77003],
  [0.09363,0.16873,0.73765],
  [0.06929,0.24478,0.68593],
  [0.04243,0.34386,0.61371],
  [0.01826,0.46323,0.51851],
  [0.00486,0.5852,0.40993],
  [0.00817,0.6913,0.30052],
  [0.02218,0.77978,0.19804],
  [0.0503,0.83185,0.11785],
  [0.0903,0.83993,0.06977],
  [0.12825,0.83134,0.0404],
  [0.16931,0.80726,0.02343],
  [0.20946,0.77699,0.01355],
  [0.24615,0.74597,0.00788],
  [0.28316,0.71236,0.00448],
  [0.31826,0.67915,0.00259],
  [0.35114,0.64734,0.00152],
  [0.38361,0.61552,0.00088],
  [0.41716,0.58232,0.00051],
  [0.44859,0.5511,0.0003],
  [0.48088,0.51894,0.00018],
  [0.51138,0.48851,0.00011],
  [0.54097,0.45896,0.00007],
  [0.56937,0.43059,0.00004],
  [0.59312,0.40685,0.00003],
  [0.61474,0.38524,0.00002],
  [0.63396,0.36602,0.00001],
  [0.65103,0.34896,0.00001],
  [0.66498,0.33502,0.00001],
  [0.67638,0.32361,0],
  [0.68596,0.31404,0],
  [0.69405,0.30595,0],
  [0.69977,0.30023,0],
  [0.70447,0.29553,0],
  [0.70871,0.29129,0],
  [0.71259,0.28741,0],
  [0.71465,0.28535,0],
  [0.71648,0.28352,0],
  [0.71824,0.28176,0],
  [0.71967,0.28033,0],
  [0.72054,0.27946,0],
  [0.72115,0.27885,0],
  [0.72158,0.27842,0],
  [0.72187,0.27813,0],
  [0.72205,0.27795,0],
  [0.72217,0.27783,0],
  [0.72219,0.27781,0],
  [0.72219,0.27781,0],
  [0.72213,0.27787,0],
  [0.72198,0.27802,0],
  [0.72182,0.27818,0],
  [0.72163,0.27837,0],
  [0.72142,0.27858,0],
  [0.7212,0.2788,0],
  [0.72091,0.27909,0],
  [0.72057,0.27943,0],
  [0.72022,0.27978,0],
  [0.71988,0.28012,0],
  [0.7195,0.2805,0],
  [0.71915,0.28085,0],
  [0.71881,0.28119,0],
  [0.71845,0.28155,0],
  [0.71807,0.28193,0],
  [0.71766,0.28234,0],
  [0.71725,0.28275,0],
  [0.71681,0.28319,0],
  [0.7163,0.2837,0],
  [0.71577,0.28423,0],
  [0.71523,0.28477,0],
  [0.71469,0.28531,0],
  [0.71418,0.28582,0],
  [0.71373,0.28627,0],
  [0.71336,0.28664,0]
];
